import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { CompanyService } from '../../services/company.service';

@Component({
  selector: 'app-ship-methods',
  templateUrl: './ship-methods.component.html',
  styleUrls: ['./ship-methods.component.scss']
})
export class ShipMethodsComponent implements OnInit {
  IsDialogMax: boolean = false;
  hostHeight: any;
  hostWidth: any;
  cvvCode: any;
  public shipMethods: any;
  userService: UserServiceModal;
  public selectedShippingMethod: string;
  constructor(
    public dialogRef: MatDialogRef<any>,
    public matDialogRef: MatDialogRef<ShipMethodsComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any, public user: UserService
, public companyService:CompanyService  ) {
    this.shipMethods = this.dialogData;
    this.userService = this.user.userServiceModal;
    this.selectedShippingMethod = this.userService.selectedShippingMethod;
  }

  ngOnInit(): void {
  }

  updateShipMethod() {
    this.dialogRef.close({ 'shipMethod': this.selectedShippingMethod });
  }

  getAvailableShippingMethods() {
    if (!this.shipMethods) {
      return [];
    }
    return this.shipMethods.filter(
      (shipmethod: any) => shipmethod.ShipMethodId !== 16
    );
  }
}
